export const actionTypes = {
  FETCH_BANK_CARDS_START: 'PAYMENT.BANK_CARDS.REQUEST_START',
  FETCH_BANK_CARDS_SUCCESS: 'PAYMENT.BANK_CARDS.REQUEST_SUCCESS',
  FETCH_BANK_CARDS_FAILURE: 'PAYMENT.BANK_CARDS.REQUEST_FAILURE',

  DELETE_BANK_CARD_START: 'PAYMENT.BANK_CARDS.DELETE_BANK_CARD_START',
  DELETE_BANK_CARD_SUCCESS: 'PAYMENT.BANK_CARDS.DELETE_BANK_CARD_SUCCESS',
  DELETE_BANK_CARD_FAILURE: 'PAYMENT.BANK_CARDS.DELETE_BANK_CARD_FAILURE',

  SET_DEFAULT_BANK_CARD_START: 'PAYMENT.BANK_CARDS.SET_DEFAULT_BANK_CARD_START',
  SET_DEFAULT_BANK_CARD_SUCCESS: 'PAYMENT.BANK_CARDS.SET_DEFAULT_BANK_CARD_SUCCESS',
  SET_DEFAULT_BANK_CARD_FAILURE: 'PAYMENT.BANK_CARDS.SET_DEFAULT_BANK_CARD_FAILURE',
};

export function startFetchRequest() {
  return {
    type: actionTypes.FETCH_BANK_CARDS_START,
  };
}

export function requestFetchSuccess(data) {
  return {
    type: actionTypes.FETCH_BANK_CARDS_SUCCESS,
    payload: data,
  };
}

export function requestFetchFailure(error) {
  return {
    type: actionTypes.FETCH_BANK_CARDS_FAILURE,
    payload: error,
  };
}

export function startDeleteRequest(cardId) {
  return {
    type: actionTypes.DELETE_BANK_CARD_START,
    payload: cardId,
  };
}

export function requestDeleteSuccess(data) {
  return {
    type: actionTypes.DELETE_BANK_CARD_SUCCESS,
    payload: data,
  };
}

export function requestDeleteFailure(error) {
  return {
    type: actionTypes.DELETE_BANK_CARD_FAILURE,
    payload: error,
  };
}

export function startSetDefaultRequest(cardId) {
  return {
    type: actionTypes.SET_DEFAULT_BANK_CARD_START,
    payload: cardId,
  };
}

export function requestSetDefaultSuccess(data) {
  return {
    type: actionTypes.SET_DEFAULT_BANK_CARD_SUCCESS,
    payload: data,
  };
}

export function requestSetDefaultFailure(error) {
  return {
    type: actionTypes.SET_DEFAULT_BANK_CARD_FAILURE,
    payload: error,
  };
}
